import { Link } from 'react-router-dom';

const Navbar = ({ user, handleLogout, cart }) => {
  const totalItems = cart.reduce((sum, items) => sum + items.cantidad, 0);
  return (
    <nav style={styles.navbar}>
      <div style={styles.container}>
        {/* Enlaces izquierda */}
        <div style={styles.linksGroup}>
         <Link to="/nosotros" style={styles.link}>NOSOTROS</Link>

          <Link to="/success" style={styles.link}>PREPARATORIA</Link>
        </div>
        {/* Logo */}
        <div style={styles.logoContainer}>
          <img
            src="LogoPC.png"
            alt="Logo principal"
            style={styles.logo}
            onClick={() => {
              localStorage.setItem("scrollTo", "informacion");
              window.location.href = "/";
            }}
          />
        </div>

        {/* Enlaces derecha */}
        <div style={styles.linksGroup}>
          <Link to="/cart" style={styles.link}>CURSOS</Link>
          <Link to="/register" style={styles.link}>ADMISIONES</Link>
        </div>
      </div>
    </nav>
  );
};

const styles = {
  navbar: {
    position: 'sticky',
    top: 0,
    zIndex: 400,
    background: 'white',
    borderBottom: '1px solid #ddd',
    fontFamily: "'Poppins', sans-serif",
    height: '85px',
    display: 'flex',
    alignItems: 'center',
    boxShadow: '0 8px 18px rgba(0, 0, 0, 0.12)',
  },
  container: {
    width: '100%',
    maxWidth: '1150px',
    margin: '0 auto',
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    gap: '20px',
  },
  linksGroup: {
    display: 'flex',
    gap: '25px',
    alignItems: 'center',
  },
  logoContainer: {
    display: 'flex',
    alignItems: 'center',
  },
  logo: {
    height: '110px',
    cursor: 'pointer',
  },
  link: {
    color: '#2c2c2c', 
    textDecoration: 'none',
    fontSize: '14px',
    fontWeight: 400,
    transition: 'color 0.3s ease',
  },
};

export default Navbar;




